var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmsFb = function SvgSmsFb(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 0.336c-1.888 0.368-3.408 1.504-4.128 3.056-0.448 0.976-0.464 1.104-0.544 4.128l-0.080 3.12-3.12 0.096v5.264h3.2v15.84h6.56v-15.824l4.4-0.096 0.176-1.376c0.112-0.768 0.24-1.968 0.304-2.688l0.112-1.296h-4.992v-3.968l0.496-0.416c0.464-0.4 0.576-0.416 2.48-0.416h1.984v-5.6l-3.072 0.016c-1.696 0.016-3.392 0.080-3.776 0.16z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms-fb.d490a1f7.svg";
export { ForwardRef as ReactComponent };